import axios from 'axios'
import { AuthModel } from '../models/AuthModel'
import { UserModel } from '../models/UserModel'
import { ResponseAPIModel } from '../../../../setup/models/ResponseAPIModel'

const API_URL = process.env.REACT_APP_API_URL || '/api'

export const GET_USER_BY_ACCESSTOKEN_URL = `${API_URL}/user/getcurrentuser`
export const LOGIN_URL = `${API_URL}/auth/login`
export const LOGOUT_URL = `${API_URL}/auth/logout`
export const VERIFY_OTP_URL = `${API_URL}/Auth/VeriftOTP`
export const REGISTER_URL = `${API_URL}/auth/register`
export const FORGOT_PASSWORD_URL = `${API_URL}/auth/forgot-password`
export const RESEND_OTP_URL = `${API_URL}/Auth/ResendOTP`;
export const RENEW_PASSWORD_TOKEN_CHECK_URL = `${API_URL}/auth/password-renew-check`
export const RENEW_PASSWORD_TOKEN_SUBMIT_URL = `${API_URL}/auth/password-renew-submit`
export const REFRESH_TOKEN_URL = `${API_URL}/auth/refresh`
export const PASSWORD_EXPIRED_URL = `${API_URL}/auth/passwordexpired`

export function login(merchantId: number, username: string, password: string) {
  return axios.post<ResponseAPIModel<AuthModel>>(LOGIN_URL, { merchantId, username, password })
}

export function logout() {
  return axios.get<ResponseAPIModel<boolean>>(LOGOUT_URL)
}

export function confirmOtp(code: string) {
  return axios.post<ResponseAPIModel<AuthModel>>(VERIFY_OTP_URL, { code })
}

export function forgotPassword(merchantId: number, username: string) {
  return axios.post<ResponseAPIModel<string>>(FORGOT_PASSWORD_URL, { username, merchantId })
}

export function renewPasswordTokenCheck(token: string | undefined) {
  return axios.post<ResponseAPIModel<string>>(RENEW_PASSWORD_TOKEN_CHECK_URL, { token: token })
}

export function renewPasswordTokenSubmit(token: string | undefined, password: string, confirmPassword: string) {
  return axios.post<ResponseAPIModel<string>>(RENEW_PASSWORD_TOKEN_SUBMIT_URL, { token: token, password, confirmPassword })
}

export function getUserByToken() {
  return axios.get<ResponseAPIModel<UserModel>>(GET_USER_BY_ACCESSTOKEN_URL)
}

export function resendOtp() {
  return axios.post<ResponseAPIModel<AuthModel>>(RESEND_OTP_URL)
}

export function refresh() {
  return axios.post<ResponseAPIModel<AuthModel>>(REFRESH_TOKEN_URL)
}

export function updateExpiredPassword(currentPassword: string | undefined, newPassword: string, confirmPassword: string) {
  return axios.post<ResponseAPIModel<AuthModel>>(PASSWORD_EXPIRED_URL, { current_password: currentPassword, new_password: newPassword, confirm_password: confirmPassword })
}